import React from 'react'
import "../App.css";

function Footer() {
    return (
        <div className="Copyrights">
            <p>Created By <a href="https://www.valis-stamatis.me/" rel="noopener noreferrer" target="_blank"> Valis Stamatis</a><br/>
            With the help of NASA Asteroids - NeoWs API
            </p>
        </div>
    )
}

export default Footer
